import { apiUser } from "../Api/ApiInstance";

export async function SaveCreditApplication(values) {
  return await apiUser.post("api/official-site/creditApplication", values);
}

export async function CreditApplications() {
  return await apiUser.get("api/official-site/creditApplication");
}
